export const TitleSec = ({ title, css }) => {
  return <h3 style={css}>{title}</h3>;
};
